var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"ts-absolute ts-text-lg",staticStyle:{"top":"20%","right":"10px"},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$parent.$emit('close')}}},[_c('i',{staticClass:"fas fa-times"})])}
var staticRenderFns = []

export { render, staticRenderFns }